import { useChartStore } from "@/stores/chartStore";
import { useDrawingStore } from "@/stores/drawingStore";
import { useSessionStore } from "@/stores/sessionStore";
import { useSettingsStore } from "@/stores/settingsStore";
import { evictStaleCandleChunks } from "@/lib/lytick/db";

export function bootstrapSession(): void {
  evictStaleCandleChunks().catch(err => console.error("Eviction job failed", err));

  const snapshot = useSessionStore.getState().checkPreviousSession();

  if (!snapshot) {
    const settings = useSettingsStore.getState();

    useChartStore.setState({
      symbol: settings.defaultSymbol,
      activeSymbolName: settings.defaultSymbol,
      timeframe: settings.defaultTimeframe,
      chartType: settings.chartType,
      sessionBootstrapped: true,
    });
    return;
  }

  useChartStore.setState({
    symbol: snapshot.symbol,
    activeSymbolName: snapshot.symbolName ?? snapshot.symbol,
    hasData: false,
    sourceGranularitySeconds: 60,
    ohlc: null,
    livePrice: null,
    priceChange: null,
    oldestEpoch: null,
    hasReachedDepthCeiling: false,
    isLoadingHistory: false,
    sessionBootstrapped: true,
  });

  if (snapshot.timeframe) {
    useChartStore.setState({ timeframe: snapshot.timeframe });
  }

  if (snapshot.chartType) {
    useChartStore.setState({ chartType: snapshot.chartType });
  }

  if (snapshot.indicators && snapshot.indicators.length > 0) {
    const first = snapshot.indicators[0];
    if (typeof first === "object" && first !== null && "id" in first) {
      useChartStore.setState({ indicators: [...snapshot.indicators] as any });
    }
  }

  if (snapshot.drawingColor) {
    useDrawingStore.setState({ drawingColor: snapshot.drawingColor });
  }
}
